/* eslint-disable */
// @generated by protobuf-ts 2.10.0 with parameter use_proto_field_name,ts_nocheck,eslint_disable,long_type_string
// @generated from protobuf file "common/v3/generic/product_add_on.proto" (package "fubo.tv.proto.common.v3.generic", syntax proto2)
// tslint:disable
// @ts-nocheck
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message fubo.tv.proto.common.v3.generic.ProductAddOn
 */
export interface ProductAddOn {
    /**
     * @generated from protobuf field: optional string code = 1;
     */
    code?: string;
    /**
     * @generated from protobuf field: optional string name = 2;
     */
    name?: string;
    /**
     * @generated from protobuf field: optional string slug = 3;
     */
    slug?: string;
    /**
     * @generated from protobuf field: optional int32 unit_amount_in_cents = 4;
     */
    unit_amount_in_cents?: number;
}
// @generated message type with reflection information, may provide speed optimized methods
class ProductAddOn$Type extends MessageType<ProductAddOn> {
    constructor() {
        super("fubo.tv.proto.common.v3.generic.ProductAddOn", [
            { no: 1, name: "code", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "name", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "slug", kind: "scalar", opt: true, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "unit_amount_in_cents", kind: "scalar", localName: "unit_amount_in_cents", opt: true, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value?: PartialMessage<ProductAddOn>): ProductAddOn {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<ProductAddOn>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProductAddOn): ProductAddOn {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* optional string code */ 1:
                    message.code = reader.string();
                    break;
                case /* optional string name */ 2:
                    message.name = reader.string();
                    break;
                case /* optional string slug */ 3:
                    message.slug = reader.string();
                    break;
                case /* optional int32 unit_amount_in_cents */ 4:
                    message.unit_amount_in_cents = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProductAddOn, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* optional string code = 1; */
        if (message.code !== undefined)
            writer.tag(1, WireType.LengthDelimited).string(message.code);
        /* optional string name = 2; */
        if (message.name !== undefined)
            writer.tag(2, WireType.LengthDelimited).string(message.name);
        /* optional string slug = 3; */
        if (message.slug !== undefined)
            writer.tag(3, WireType.LengthDelimited).string(message.slug);
        /* optional int32 unit_amount_in_cents = 4; */
        if (message.unit_amount_in_cents !== undefined)
            writer.tag(4, WireType.Varint).int32(message.unit_amount_in_cents);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message fubo.tv.proto.common.v3.generic.ProductAddOn
 */
export const ProductAddOn = new ProductAddOn$Type();
